var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',_vm._b({model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},'v-dialog',_vm.dialogProps,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }